import { render, staticRenderFns } from "./addDepartment.vue?vue&type=template&id=3bab5450&scoped=true"
import script from "./addDepartment.vue?vue&type=script&lang=js"
export * from "./addDepartment.vue?vue&type=script&lang=js"
import style0 from "./addDepartment.vue?vue&type=style&index=0&id=3bab5450&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3bab5450",
  null
  
)

export default component.exports